import React from 'react'

import { Outcome } from '@app/graphql/types'
import { BenchmarkDeviationsCheckResultsTable } from '@app/modules/Messages/Components/UtilityBillAICheckResults/CheckResults/BenchmarkDeviationsCheckResultsTable'
import { CheckResultsLayout } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/CheckResultsLayout'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'

export type BenchmarkDeviationsCheckResultsProps = {
  check: UtilityBillAnalysisChecks['benchmarkDeviations']
}

export const BenchmarkDeviationsCheckResults = ({
  check
}: BenchmarkDeviationsCheckResultsProps) => {
  if (check.outcome === Outcome.Pass) {
    return null
  }

  return (
    <CheckResultsLayout>
      <CheckResultsLayout.Title>Vergleichswerte</CheckResultsLayout.Title>
      <CheckResultsLayout.Description>
        Folgende Positionen sind im Vergleich mit statistischen Durchschnittswerten der vergangenen
        Jahre überdurchschnittlich hoch und daher auffällig.
      </CheckResultsLayout.Description>
      <BenchmarkDeviationsCheckResultsTable check={check} />
    </CheckResultsLayout>
  )
}
